/** Chinese UI copy → English. Unlisted strings stay Chinese. */
export default {
  "返回": "Back",
  "请输入内容": "Enter name",
  "宽": "W",
  "高": "H",
  "对齐": "Align",
  "分布": "Distribute",
  "快捷键": "Shortcuts",
  "撤销": "Undo",
  "清空": "Clear",
  "保存": "Save",
  "批量设置": "Batch",
  "组合": "Group",
  "拆分": "Ungroup",
  "锁定": "Lock",
  "解锁": "Unlock",
  "左对齐": "Align left",
  "右对齐": "Align right",
  "上对齐": "Align top",
  "下对齐": "Align bottom",
  "垂直居中": "Align middle",
  "水平等距": "Distribute H",
  "垂直等距": "Distribute V",
  "交互包": "I/O pack",
  "预览": "Preview",
  "保存工程": "Save project",
  "加入AI对话": "Add to AI chat",
  "复制": "Copy",
  "粘贴": "Paste",
  "剪切": "Cut",
  "删除": "Delete",
  "置顶": "Bring to front",
  "置底": "Send to back",
  "上移一层": "Bring forward",
  "下移一层": "Send backward",
  "请先选中要加入对话的组件": "Select components to add to chat",
  "新增": "Add",
  "新增子页面": "Add subpage",
  "排序": "Sort",
  "元素": "Elements",
  "定位画布": "Center canvas",
  "复制页面": "Duplicate page",
  "页面至少要保留一个": "Keep at least one page",
  "矩阵": "Matrix",
  "输入": "Input",
  "输出": "Output",
  "执行": "Execute",
  "文字": "Text",
  "线条": "Line",
  "方形按钮": "Square button",
  "圆形按钮": "Round button",
  "圆角按钮": "Rounded button",
  "图片": "Image",
  "流媒体": "RTSP",
  "视频": "Video",
  "音乐": "Audio",
  "天气": "Weather",
  "多图轮播": "Carousel",
  "时间": "Clock",
  "环境组件": "Environment",
  "文档": "Document",
  "网页": "Web view",
  "滑块": "Slider",
  "状态灯": "Status light",
  "子页面": "Subpage",
  "可视化": "Chart",
  "位置属性": "Position",
  "组件属性": "Component",
  "组件联动（预览生效）": "Links (preview)",
  "秒": "s",
  "请选择": "Select",
  "添加": "Add",
  "名称": "Name",
  "rtsp流地址": "RTSP URL",
  "文件名称": "File name",
  "添加资源": "Add media",
  "颜色": "Color",
  "图标": "Icon",
  "请选择": "Select",
  "清空": "Clear",
  "圆角": "Radius",
  "透明度": "Opacity",
  "字体大小": "Font size",
  "字体颜色": "Font color",
  "字体": "Font",
  "按钮名称": "Button text",
  "按钮按压名称": "Pressed text",
  "别名": "Alias",
  "按钮loading": "Button loading",
  "持续时间": "Duration",
  "开启定时": "Timer",
  "是否单击按钮": "Single click",
  "是否开启弹窗确认": "Confirm dialog",
  "是否开启按压音效": "Press sound",
  "背景": "Background",
  "背景颜色": "Background color",
  "背景图": "Background image",
  "按压背景": "Pressed background",
  "按压颜色": "Pressed color",
  "按钮按压背景图": "Pressed image",
  "图标选择": "Icon",
  "图片资源": "Image",
  "图片尺寸": "Image size",
  "允许变更": "Allow change",
  "内容": "Content",
  "文字滚动开启": "Marquee",
  "滚动方向": "Scroll direction",
  "滚动速度": "Scroll speed",
  "Rtsp流地址": "RTSP URLs",
  "视频文件名称": "Video file",
  "循环播放": "Loop",
  "音乐文件名称": "Audio file",
  "网页地址": "URL",
  "方向": "Direction",
  "横向": "Horizontal",
  "纵向": "Vertical",
  "圆点颜色": "Thumb color",
  "圆点大小": "Thumb size",
  "轨道颜色": "Track color",
  "滑动颜色": "Active color",
  "轨道大小": "Track size",
  "文档文件名称": "Document file",
  "背景图片": "Background image",
  "页面名称": "Page name",
  "网格": "Grid",
  "背景色": "Background",
  "是否展示到菜单": "Show in menu",
  "城市": "City",
  "样式": "Style",
  "图片列表": "Images",
  "轮播间隔": "Interval",
  "启用状态log记录": "Status log",
  "设备名称": "Device name",
  "IP地址": "IP address",
  "端口号": "Port",
  "输入位": "Inputs",
  "输出位": "Outputs",
  "规则引擎": "Rule engine",
  "端口": "Port",
  "按压指令": "Press command",
  "二次按压指令": "Second press",
  "单元设置": "Units",
  "空心字体": "Hollow",
  "米开飘逸行楷减细版字体": "Xingkai",
  "arial unicode ms字体": "Arial Unicode MS",
  "arial bold字体": "Arial Bold",
  "功能说明": "Help",
  "用法": "How",
  "影响": "Effect",
  "画布快捷键": "Canvas shortcuts",
  "知道了": "OK",
  "编辑": "Edit",
  "组合与锁定": "Group & lock",
  "画布视图": "View",
  "选择": "Select",
  "移动选中": "Nudge",
  "撤销上一步操作": "Undo",
  "重做": "Redo",
  "保存当前页面到草稿": "Save page draft",
  "复制选中组件": "Copy selection",
  "剪切选中组件": "Cut selection",
  "在鼠标位置附近粘贴组件": "Paste near cursor",
  "删除选中组件或多选组件": "Delete selection",
  "清空画布（保留背景）": "Clear canvas (keep background)",
  "组合框选组件": "Group selection",
  "拆分组合组件": "Ungroup",
  "锁定当前组件": "Lock",
  "解锁当前组件": "Unlock",
  "以鼠标位置为锚点缩放画布": "Zoom at cursor",
  "平移画布视口": "Pan canvas",
  "页面列表定位图标": "Center page in view",
  "展开或收起左侧页面栏": "Toggle left panel",
  "展开或收起右侧属性栏": "Toggle right panel",
  "框选区域内组件；含多种类型时松手后可筛选类型": "Marquee select; filter types if mixed",
  "点选追加或取消多选（不误框其它元素）": "Add/remove from multi-select",
  "微移选中组件或框选区域（每次 1px）": "Nudge 1px",
  "展开左侧 (Alt+1)": "Expand left (Alt+1)",
  "收起左侧 (Alt+1)": "Collapse left (Alt+1)",
  "展开右侧 (Alt+2)": "Expand right (Alt+2)",
  "收起右侧 (Alt+2)": "Collapse right (Alt+2)",
  "绑定事件": "Events",
  "添加指令": "Add command",
  "当视频播放到第": "When video reaches",
  "未设置": "Not set",
  "已设置": "Set",
  "点击绑定": "Click bind",
  "请选择绑定组件": "Select component",
  "请选择事件": "Select event",
  "互斥事件": "Mutex",
  "跳转事件": "Navigate",
  "联动事件": "Link",
  "再次按压联动事件": "Second-press link",
  "开始": "Play",
  "暂停": "Pause",
  "继续": "Resume",
  "停止": "Stop",
  "重播": "Replay",
  "音量加": "Volume up",
  "音量减": "Volume down",
  "静音": "Mute",
  "解除静音": "Unmute",
  "上一页": "Previous",
  "下一页": "Next",
  "上一步": "Previous step",
  "下一步": "Next step",
  "已配置指令或事件": "Has commands or events",
  "生态控件": "Eco control",
  "基本控件": "Basic",
  "删除当前按钮会清空组内所有按钮，确定要删除吗？": "Deleting this button clears the group. Continue?",
  "确定要删除吗": "Delete?",
  "确定要删除吗？": "Delete?",
  "请先点击选择要解锁的组件": "Select a component to unlock",
  "请先解锁父组件，才能解锁当前组件": "Unlock the parent first",
  "请先点击选择要锁定组件": "Select a component to lock",
  "智能工具箱": "Smart toolbox",
  "点击展开智能工具箱": "Open smart toolbox",
  "智能工具箱，可拖到边缘吸附": "Drag to dock on an edge",
  "即将开放": "Coming soon",
  "敬请期待": "Coming soon",
  "嗨，我是智能工具箱～": "Hi, this is the smart toolbox.",
  "点击我查看我有什么功能吧": "Open it to see available tools.",
  "AI助手": "AI assistant",
  "打开/收起画布 AI（Alt+3）": "Toggle canvas AI (Alt+3)",
  "当前账号未开通画布AI": "Canvas AI is not enabled for this account",
  "更多智能小工具即将上线": "More tools coming soon",
  "按钮成图": "Button to image",
  "实时预览": "Preview",
  "浅底": "Light",
  "深底": "Dark",
  "透明格": "Checker",
  "按钮文字": "Label",
  "如：确定": "e.g. OK",
  "尺寸": "Size",
  "无背景": "No fill",
  "文字颜色": "Text color",
  "文字大小": "Text size",
  "文字字体": "Font",
  "默认字体": "Default font",
  "字重": "Weight",
  "常规": "Regular",
  "中等": "Medium",
  "加粗": "Bold",
  "边框": "Border",
  "取 消": "Cancel",
  "取消": "Cancel",
  "下载图片": "Download",
  "保存到私有素材库": "Save to private library",
  "按钮": "Button",
  "圆形": "Round",
  "方形": "Square",
  "已开始下载": "Download started",
  "已保存到私有素材库": "Saved to private library",
  "保存失败": "Save failed",
  "保存失败，请检查网络": "Save failed. Check the network.",
  "把圆形、方形、圆角按钮做成透明底 PNG，可下载或存入私有素材库，方便当图片按钮使用。":
    "Export round, square, or rounded buttons as PNG. Download or save to the private library.",
  "收起 (Alt+3)": "Collapse (Alt+3)",
  "智能画布助手": "Canvas assistant",
  "预览中": "Previewing",
  "按压态": "Pressed",
  "普通态": "Normal",
  "思考中...": "Thinking...",
  "已生成操作计划": "Plan ready",
  "右键组件「加入AI对话」，或先点选再描述修改，例如：名字改成123，字改红色":
    'Right-click “Add to AI chat”, or select then describe a change, e.g. rename to 123, make text red',
  "应用": "Apply",
  "发送": "Send",
  "辅助工具下载": "Downloads",
  "工程模板": "Project templates",
  "更多模板": "More templates",
  "快速上手指南": "Quick start guide",
  "工程名称：": "Project name:",
  "工程名称": "Project name",
  "请输入工程名称": "Project name",
  "搜索": "Search",
  "工程图片": "Thumbnail",
  "画布宽度": "Width",
  "画布高度": "Height",
  "工程属性": "Type",
  "创建时间": "Created",
  "修改时间": "Updated",
  "操作": "Actions",
  "新建工程": "New project",
  "导入智探画布": "Import probe canvas",
  "工程复制": "Duplicate",
  "工程删除": "Delete",
  "工程交接": "Transfer",
  "查询": "Search",
  "重置": "Reset",
  "确定": "OK",
  "提交": "Submit",
  "详情": "Details",
  "新增": "Add",
  "编辑": "Edit",
  "修改": "Edit",
  "查看": "View",
  "上传": "Upload",
  "上传图片": "Upload image",
  "分享": "Share",
  "创建": "Create",
  "导出中": "Exporting",
  "工程等级": "Project level",
  "页面数量": "Pages",
  "交接": "Transfer",
  "下载": "Download",
  "导出": "Export",
  "导入": "Import",
  "启用": "Enable",
  "禁用": "Disable",
  "状态": "Status",
  "备注": "Remark",
  "类型": "Type",
  "序号": "No.",
  "用户名": "Username",
  "手机号": "Phone",
  "角色": "Role",
  "权限": "Permission",
  "待审批": "Pending",
  "审批通过": "Approved",
  "审批驳回": "Rejected",
  "模板管理": "Templates",
  "apk新增": "Add APK",
  "apk修改": "Edit APK",
  "qt新增": "Add QT",
  "qt修改": "Edit QT",
  "公共指令新增": "Add public command",
  "公共指令编辑": "Edit public command",
  "公共指令查看": "View public command",
  "只能插入图片": "Images only",
  "默认图片": "Default image",
  "已选": "Selected",
  "个资源": " items",
  "绑定指令": "Bind commands",
  "私有指令": "Private commands",
  "公共指令": "Public commands",
  "请输入指令名称": "Command name",
  "指令类型": "Command type",
  "指令名称": "Name",
  "指令码": "Code",
  "指令回码": "Ack",
  "顺序": "Order",
  "返回值校验": "Validate return",
  "跳转至": "Jump to",
  "绑定子页面": "Bind subpage",
  "批量设置当前页面的按钮": "Batch set page buttons",
  "批量设置按钮属性": "Batch button properties",
  "更改页面顺序": "Reorder pages",
  "批量设置": "Batch set",
  "请输入IP": "IP address",
  "请输入端口号": "Port",
  "延时（毫秒）": "Delay (ms)",
  "请输入延时时间": "Delay",
  "次数": "Times",
  "轮播图片": "Carousel images",
  "已添加": "Added",
  "张": "",
  "添加图片": "Add image",
  "我的素材": "My media",
  "公共素材": "Public media",
  "刷新": "Refresh",
  "快捷入口": "Quick access",
  "请选择图片": "Select an image",
  "协议列表": "Protocols",
  "添加协议": "Add protocol",
  "指令集设置": "Command set",
  "按钮状态设置": "Button states",
  "导入智探现场工程": "Import probe project",
  "提示": "Notice",
  "是": "Yes",
  "否": "No",
  "打开编辑": "Open editor",
  "稍后": "Later",
  "是否保存当前画布？": "Save the current canvas?",
  "确认执行该操作？": "Confirm this action?",
  "操作确认": "Confirm",
  "绑定微信": "Bind WeChat",
  "解绑微信": "Unbind WeChat",
  "生成密钥": "Generate key",
  "绑定密钥": "Bind key",
  "修改密钥时长": "Edit key duration",
  "调用信息": "API info",
  "编辑模型": "Edit model",
  "添加模型": "Add model",
  "重置密码": "Reset password",
  "确定删除吗？": "Delete?",
  "确定要删除当前数据吗？": "Delete this item?",
  "确定要重置吗？": "Reset?",
  "确定要更新吗？": "Update?",
  "请输入：": "Enter:",
  "白名单设置": "Allow list",
  "添加素材": "Add media",
  "上传素材": "Upload media",
  "驳回原因": "Reject reason",
  "图片查看": "Preview image",
  "新手引导": "Getting started",
  "运营客服": "Support",
  "关闭预览": "Close preview",
  "名称：": "Name:",
  "请输入名称": "Name",
  "请输入手机号": "Phone number",
  "昵称：": "Nickname:",
  "请输入昵称": "Nickname",
  "手机号：": "Phone:",
  "请输入邮箱": "Email",
  "共": "Total",
  "个": "",
  "0为按钮初始状态，1为按钮按压状态": "0 = default, 1 = pressed",
  "确定删除该条数据？": "Delete this row?",
  "确定要将本次交互包的改变更新吗?": "Save I/O pack changes?",
  "导入成功，是否立即打开编辑器？": "Imported. Open the editor now?",
  "确认要删除勾选的工程吗？": "Delete selected projects?",
  "当前为初始密码，请先修改密码后再使用其它功能": "Change the initial password before using other features.",
  "立即刷新": "Refresh now",
  "版本更新": "Update",
  "检测到系统已发布新版本，请刷新页面以加载最新资源。": "A new version is available. Refresh to load the latest files.",
  "检测到有未保存的变更，是否载入？": "Unsaved changes found. Load them?",
  "确 定": "OK",
  "上移": "Up",
  "下移": "Down",
  "全选": "Select all",
  "还没有轮播图片": "No carousel images yet",
  "保 存": "Save",
  "未命名": "Untitled",
  "动画配置": "animation",
  "动画时长：": "Duration:",
  "是否循环：": "Loop:",
  "保存到私有素材库": "Save to private library",
  "16进制": "Hex",
  "CPU序列号": "CPU serial",
  "IP访问限制": "IP allow list",
  "MAC地址": "MAC address",
  "OpenAI 地址": "OpenAI URL",
  "SN号码": "SN",
  "TCP/IP协议": "TCP/IP",
  "json格式": "JSON",
  "个数": "Count",
  "主板序列号": "Board serial",
  "代码": "Code",
  "停用": "Disabled",
  "免费额度到期日": "Free quota ends",
  "全部": "All",
  "冻结时间": "Frozen until",
  "加入回车/空格": "CR/LF",
  "加入回车/换行": "CR/LF",
  "协议类型": "Protocol",
  "单位": "Unit",
  "卡片上展示的名字": "Display name",
  "原手机验证码": "Old SMS code",
  "原用户": "From user",
  "发送方式": "Send via",
  "只允许特定IP进行访问请求，不限制则无需填写": "Leave empty to allow all IPs",
  "可修改导入后的工程名称": "Project name after import",
  "可选": "Optional",
  "回车/空格": "CR/LF",
  "图片名称": "Image name",
  "图片类型": "Image type",
  "备注信息": "Remark",
  "失效": "Expires",
  "失效时间": "Expiry",
  "姓名": "Name",
  "字符串": "String",
  "密钥描述": "Key description",
  "密钥级别": "Key level",
  "尊贵版": "Premium",
  "屏蔽数据(用途中存在测试字样)": "Hide test-purpose rows",
  "平台": "Platform",
  "形态": "Type",
  "必填，请输入": "Required",
  "性别": "Gender",
  "指令 IP": "Command IP",
  "指令类型名称名称": "Type name",
  "指令进制": "Encoding",
  "按钮别名": "Button alias",
  "接收用户": "To user",
  "控制台里的模型 Code": "Model code in console",
  "描述": "Description",
  "操作人": "Operator",
  "操作人类型": "Operator type",
  "新密码": "New password",
  "新密码，不少于 6 位": "New password, at least 6 characters",
  "新手机号": "New phone",
  "新手机验证码": "New SMS code",
  "旗舰版": "Flagship",
  "是否启用": "Enabled",
  "显示名称": "Display name",
  "有效期": "Valid until",
  "查看上方页面": "Previous page",
  "查看下方页面": "Next page",
  "模型 Code": "Model code",
  "消息进制": "Message encoding",
  "激活用户(手机号)": "Activated by (phone)",
  "生成时间": "Generated",
  "生效": "Effective",
  "生效时间": "Effective from",
  "用户手机号关键字": "Phone keyword",
  "用途": "Purpose",
  "短信验证码": "SMS code",
  "确定要删除吗？": "Delete?",
  "确定要删除当前节点吗？": "Delete this node?",
  "确认密码": "Confirm password",
  "签名版": "Signed",
  "级别": "Level",
  "腾讯云": "Tencent Cloud",
  "设备SN": "Device SN",
  "设备SN关键字": "SN keyword",
  "证书失效时间": "Cert expiry",
  "证书生效时间": "Cert start",
  "请求体": "Body",
  "请求体类型": "Body type",
  "请求头": "Headers",
  "请求方式": "Method",
  "请输入": "Enter",
  "请输入关键字": "Keyword",
  "请输入冻结时间": "Frozen until",
  "请输入密码": "Password",
  "请输入密钥描述": "Key description",
  "请输入指令回码": "Ack code",
  "请输入模板名称：": "Template name",
  "请输入次数": "Times",
  "请输入用途": "Purpose",
  "请输入确认密码": "Confirm password",
  "请输入返回值校验": "Return check",
  "请输入需要跳转的页数": "Page number",
  "请选择上传菜单": "Select menu",
  "请选择工程等级": "Project level",
  "请选择活动区域": "Select region",
  "请选择监听事件": "Select event",
  "请选择类型": "Select type",
  "请选择联动组件": "Select component",
  "请选择请求方式": "Select method",
  "账号安全": "Security",
  "账号资料": "Profile",
  "资源用量": "Usage",
  "输入关键字进行过滤": "Filter by keyword",
  "选填": "Optional",
  "选择日期时间": "Date and time",
  "逗号分隔": "Comma-separated",
  "逗号分隔，例如 127.0.0.1,10.0.0.2": "Comma-separated, e.g. 127.0.0.1,10.0.0.2",
  "逗号分隔，例如 sn1001,sn1002": "Comma-separated, e.g. sn1001,sn1002",
  "邮箱：": "Email:",
  "阿里云": "Alibaba Cloud",
  "麒麟V10": "Kylin V10",
  "时间": "Time",
  "工程": "Project",
  "批量删除": "Batch delete",
  "一键全开 AI": "Enable AI for all",
  "一键全关 AI": "Disable AI for all",
  "状态：": "Status:",
  "用量": "Usage",
  "正常": "Active",
  "重置密码": "Reset password",
  "已重置": "Reset done",
  "将密码重置为 123456，并强制下次登录改密，同时踢出在线会话？":
    "Reset the password to 123456, require a change at next login, and sign out active sessions?",
  "冻结": "Frozen",
  "签名版（测试版）": "Signature (Beta)",
  "UI设计创建画布页面限制≤1个，UI设计画布中按钮无限制，UI设计按钮添加指令时指令关联IP地址限制≤10个。":
    "Canvas pages ≤ 1. Unlimited buttons. Command-bound IPs ≤ 10.",
  "UI设计创建画布页面限制≤5个，UI设计画布中按钮无限制，UI设计按钮添加指令时指令关联IP地址限制≤30个。":
    "Canvas pages ≤ 5. Unlimited buttons. Command-bound IPs ≤ 30.",
  "UI设计创建画布页面限制≤99个，UI设计画布中按钮无限制，UI设计按钮添加指令时指令关联IP地址限制≤999个。":
    "Canvas pages ≤ 99. Unlimited buttons. Command-bound IPs ≤ 999.",
  "UI设计画布中所有组件 文字、按钮、图片、时间、环境组件、多图轮播、天气、矩阵、流媒体、视频、文档、生态组件 等 全部畅享使用无限制！":
    "All canvas widgets are unlimited: text, button, image, time, environment, carousel, weather, matrix, stream, video, document, ecology, and more.",
  "密钥绑定《签名版密钥》即可。密钥等级 旗舰版>尊贵版>签名版 高密钥兼容低版本！":
    "Bind a Signature key. Rank: Flagship > Premium > Signature. Higher keys work on lower tiers.",
  "密钥绑定《尊贵版密钥》即可。密钥等级 旗舰版>尊贵版>签名版 高密钥兼容低版本！":
    "Bind a Premium key. Rank: Flagship > Premium > Signature. Higher keys work on lower tiers.",
  "密钥绑定《旗舰版密钥》即可。密钥等级 旗舰版>尊贵版>签名版 高密钥兼容低版本！":
    "Bind a Flagship key. Rank: Flagship > Premium > Signature. Higher keys work on lower tiers.",
  "购买或合作请添加首页企业微信联系我们。":
    "For purchase or partnership, add the homepage WeCom contact.",
  "购买或合作请添加首页企业微信联系我们。并获取画布设计指导。":
    "For purchase or partnership, add the homepage WeCom contact. Includes canvas design guidance.",
  "购买或合作请添加首页企业微信联系我们。并获取画布设计使用一对一项目指导。":
    "For purchase or partnership, add the homepage WeCom contact. Includes one-on-one canvas project guidance.",
  "管理员电话：": "Admin phone:",
  "模板名称：": "Template name:",
  "指令类型名称：": "Command type:",
  "指令名称：": "Command:",
  "类型：": "Type:",
  "素材名称：": "Asset name:",
  "问题：": "Question:",
  "答案：": "Answer:",
  "列表": "List",
  "树形": "Tree",
  "添加管理员": "Add admin",
  "确认保存": "Save",
  "开始上传": "Upload",
  "选取文件": "Choose file",
  "查看详情": "Details",
  "查看存档": "Archive",
  "改派": "Reassign",
  "添加文档": "Add document",
  "添加私有指令": "Add private command",
  "添加动画": "Add animation",
  "预览动画": "Preview animation",
  "添加属性": "Add property",
  "添加组件": "Add component",
  "跳过引导": "Skip tour",
  "上一步": "Back",
  "知道了": "Got it",
  "无需学习": "Skip learning",
  "保存用量": "Save quota",
  "保存资料": "Save profile",
  "发送验证码": "Send code",
  "绑定微信": "Bind WeChat",
  "解绑微信": "Unbind WeChat",
  "全部工程": "All projects",
  "确认绑定": "Confirm bind",
  "确认解绑": "Confirm unbind",
  "调用信息": "API settings",
  "添加模型": "Add model",
  "生成并下载 LICENSE": "Generate and download LICENSE",
  "快速移动": "Jump",
  "批量设置": "Batch set",
  "强校验": "Strict check",
  "应用": "Apply",
  "更新": "Update",
  "上移": "Up",
  "下移": "Down",
  "打开": "Open",
  "同意": "Approve",
  "驳回": "Reject",
  "X代表输入按键中的输入位": "X is the input index of the input key.",
  "Y代表输出按键中的输出位": "Y is the output index of the output key.",
  "至": "to",
  "开始日期": "Start date",
  "结束日期": "End date",
  "暂无记录": "No records",
  "暂无工程": "No projects",
  "页面加载中...": "Loading page...",
  "请先按昵称或手机号搜索": "Search by nickname or phone first",
  "未找到匹配用户": "No matching user",
  "请先搜索接收人": "Search for a recipient first",
  "请求地址": "Request URL",
  "请输入请求地址": "Enter request URL",
  "请输入指令码": "Enter command code",
  "键值对": "Key-value",
  "回车": "CR",
  "空格": "Space",
  "换行": "LF",
  "回车+换行": "CR+LF",
  "换行/回车": "LF/CR",
  "运行时仅播放第一组地址，请删除多余组":
    "Only the first RTSP URL is played; remove extra groups",
  "预览": "Preview",
  "消息": "Message",
  "请输入消息": "Enter message",
  "待选指令": "Available commands",
  "已选指令": "Selected commands",
  "条": "items",
  "未命名页面": "Untitled page",
  "未命名按钮": "Untitled button",
  "暂无匹配按钮": "No matching buttons",
  "请勾选左侧要添加的数据": "Select items on the left to add",
  "请勾选右侧要移除的数据": "Select items on the right to remove",
  "页面": "Page",
  "请输入正确的IP地址": "Enter a valid IP address",
  "请求体请填写正确的json格式": "Request body must be valid JSON",
  "请求体中存在空的值，请检查并补全": "Request body has empty fields. Please complete them",
  "生成设备本地 license.lic 并下载。IP / MAC / SN 至少填一种。":
    "Generate and download a local license.lic. Fill in at least one of IP / MAC / SN.",
  "生成历史（仅超级管理员可见）": "History (super admin only)",
  "敬请期待": "Coming soon",
  "开启且未过期的模型按到期日从早到晚自动选用；调用失败会换下一个。":
    "Enabled, unexpired models are used by earliest expiry. Failover goes to the next.",
  "到期": "Expires",
  "还没有模型，点击「添加模型」": "No models yet. Click Add model.",
  "不填则保持原 Key": "Leave blank to keep the current key",
  "编辑模型": "Edit model",
  "只改这个账号自己能带多少工程、多少页配置上限、多少存储（MB）。不改形态套餐，也不限制按钮。":
    "Only this account's project count, page cap, and storage (MB). Does not change edition packages or button limits.",
  "登录密码": "Password",
  "通过当前手机短信验证后设置新密码": "Verify by SMS on the current phone, then set a new password",
  "当前绑定": "Bound to",
  "未绑定": "Not bound",
  "更换需验证原号码和新号码。": "Changing requires verifying the old and new numbers.",
  "已绑定微信，解绑后需重新扫码。": "WeChat is bound. Unbind to scan again.",
  "未绑定。绑定前请先完成短信验证。": "Not bound. Complete SMS verification first.",
  "工程个数和存储按账号计算。每个工程的页数、指令 IP 按创建时选择的形态（签名 / 尊贵 / 旗舰）。按钮不限制，只统计已用个数。":
    "Project count and storage are per account. Pages and command IPs follow the edition chosen at create. Buttons are unlimited; usage is counted.",
  "工程画布用量": "Canvas usage",
  "页已满": "Pages full",
  "IP 已满": "IPs full",
  "（不限）": " (unlimited)",
  "请先发送短信验证码，再扫码。若该微信已被其它账号占用，需对方先解绑。":
    "Send an SMS code, then scan. If this WeChat is used by another account, they must unbind first.",
  "工程已删除": "Project deleted",
  "未命名用户": "Unnamed user",
  "序列号": "Serial",
  "注册于": "Registered",
  "点击头像更换（自动压缩为 200×200）": "Click the avatar to change (auto-resized to 200×200)",
  "男": "Male",
  "女": "Female",
  "未知": "Unknown",
  "请先添加子页面，再去绑定": "Add a subpage first, then bind it",
  "选择要保留的类型": "Keep this type",
  "全部": "All",
  "取消框选": "Cancel selection",
  "json格式": "JSON",
  "编码格式": "Encoding",
  "指令类别": "Category",
  "创建者": "Creator",
  "指令类型名称": "Type name",
  "管理员名称": "Admin name",
  "管理员电话": "Admin phone",
  "管理员账号": "Admin account",
  "用户名称": "User name",
  "电话号码": "Phone",
  "近一次登录时间": "Last login",
  "随机序列号": "Serial",
  "AI可见": "AI visible",
  "角色名称": "Role",
  "菜单名称": "Menu",
  "菜单顺序": "Order",
  "上级名称": "Parent",
  "画布高度": "Height",
  "发送码": "Send code",
  "模板名称": "Template",
  "模板封面": "Cover",
  "提交人": "Submitter",
  "提交描述": "Description",
  "提交时间": "Submitted",
  "处理时间": "Handled",
  "密钥": "Key",
  "密钥时长": "Valid period",
  "密钥激活时间": "Activated",
  "激活用户": "Activated user",
  "用户电话": "User phone",
  "apk名称": "APK name",
  "qt名称": "QT name",
  "apk版本": "APK version",
  "qt版本": "QT version",
  "下载地址": "Download URL",
  "展示到首页": "Show on home",
  "创建人": "Created by",
  "创建日期": "Created",
  "版本说明": "Release notes",
  "白名单": "Allow list",
  "白名单状态": "Allow-list status",
  "图片路径": "Image path",
  "图片大小（kb）": "Size (KB)",
  "免费容量（M）": "Storage (MB)",
  "工程数量": "Projects",
  "页面个数": "Pages",
  "注册时间": "Registered",
  "修改时间": "Updated",
  "回车/换行": "CR+LF",
  "启用": "On",
  "停用": "Off",
  "x坐标": "X",
  "y坐标": "Y",
  "上传apk": "Upload APK",
  "上传qt": "Upload QT",
  "公司名称": "Company",
  "再次点击": "Click again",
  "初始状态": "Idle",
  "参数值": "Value",
  "参数名": "Param",
  "品牌型号": "Model",
  "地址": "URL",
  "存储": "Storage",
  "宽度": "Width",
  "按压名称": "Pressed name",
  "按压效果": "Pressed look",
  "按压状态": "Pressed",
  "按压背景图": "Pressed image",
  "按压背景颜色": "Pressed color",
  "昵称": "Nickname",
  "更新日志": "Changelog",
  "更新时间": "Updated",
  "点击": "Click",
  "版本号": "Version",
  "电话": "Phone",
  "答案": "Answer",
  "触发事件": "Event",
  "账号": "Account",
  "邮箱": "Email",
  "问题": "Question",
  "高度": "Height",
  "未知级别": "Unknown tier",
  "未知属性": "Unknown type",
  "未知用户": "Unknown user",
  "于": "at",
  "生成了": "generated",
  "管理员": "Admin",
  "用户": "User",
  "JSON 文件": "JSON file",
  "工程等级": "Edition",
  "确认导入": "Import",
  "画布尺寸：": "Canvas size:",
  "页面数量：": "Pages:",
  "工程": "Project",
  "未激活": "Inactive",
  "已激活": "Active",
  "待审批": "Pending",
  "审批通过": "Approved",
  "审批驳回": "Rejected",
  "复制下载地址": "Copy download URL",
  "没有下载地址": "No download URL",
  "已复制下载地址": "Download URL copied",
  "复制失败": "Copy failed",
  "麒麟版本可上传任意格式安装包（文件名需带后缀）":
    "Kylin: any installer format (filename must have an extension)",
  "Windows 请上传 .exe": "Windows: upload a .exe",
  "Windows 请上传 .exe 文件": "Windows: upload a .exe file",
  "文件名称缺少后缀": "Filename needs an extension",
  "点击或拖拽文件到此处上传": "Click or drag file here to upload",
  "支持断点续传，大文件可放心上传": "Resumable upload supported for large files",
  "移除": "Remove",
  "文件格式不符合要求": "File format not allowed",
  "上传失败": "Upload failed",
  "只能上传apk文件": "Only .apk files are allowed",
  "客户端下载": "Client downloads",
  "安卓端": "Android",
  "Windows端": "Windows",
  "麒麟系统": "Kylin OS",
  "暂无下载": "No download available",
  "APK下载": "APK download",
  "QT下载": "QT download",
  "QT(麒麟V10触摸屏)": "QT (Kylin V10 touch)",
  "请先勾选要删除的数据": "Select rows to delete first",
  "请先勾选要操作的数据": "Select rows to update first",
  "请先勾选要上移的数据": "Select a row to move up",
  "请先勾选要下移的数据": "Select a row to move down",
  "请先勾选要移动的数据": "Select a row to move",
  "请先勾选要批量设置的数据": "Select rows for batch settings",
  "只能选择一条数据去移动": "Select only one row to move",
  "只能选择一条数据去上移": "Select only one row to move up",
  "只能选择一条数据去下移": "Select only one row to move down",
  "已经在第一条，不能再上移了": "Already at the first row",
  "已经在最后一条，不能再下移了": "Already at the last row",
  "右侧没有要更新的数据": "Nothing to update on the right",
  "请先勾选要批量设置的按钮": "Select buttons for batch settings",
  "请点击选择要绑定的指令数据": "Select a command to bind",
  "存在不正确的ip地址，请检查并修改": "Invalid IP address. Please fix",
  "强校验勾选时，返回值校验不能为空": "Return validation is required when strict check is on",
  "IP和端口号相同的个数不得超过最高限制": "Too many identical IP and port pairs",
  "行数最大为": "Maximum rows: ",
  "没必要跳到同一行哦~": "No need to jump to the same row",
  "跳转事件最多可配置一个页面": "Jump event allows only one page",
  "不能为空": "Required",
  "页面名称不能超过8个字符": "Page name cannot exceed 8 characters",
  "别名不能为空": "Alias is required when timer is enabled",
  "别名不能重复": "Duplicate alias",
  "至少要有两个": "At least two items required",
  "每一个的单位、代码都不能为空": "Unit and code cannot be empty",
  "至少要有一个": "At least one item required",
  "文件名称不能为空": "File name is required",
  "请输入指令名称": "Enter command name",
  "请输入指令码": "Enter command code",
  "请输入请求地址": "Enter request URL",
  "JSON 解析失败，请选择智探导出的有效文件": "Invalid JSON. Use a valid WeTab export file",
  "文件读取失败": "Failed to read file",
  "请先选择并解析 JSON 文件": "Select and parse a JSON file first",
  "请选择工程等级": "Select project edition",
  "请填写工程名称": "Enter project name",
  "正在后台打包中......工程打包时长与工程体积大小有关！请您耐心等待!":
    "Packaging in background. Time depends on project size. Please wait.",
  "此工程未行打包或者打包未完成！请执行打包或等待！":
    "Packaging not started or not finished. Pack or wait.",
  "请选择工程": "Select a project",
  "工程等级信息加载中，请稍后重试": "Loading edition info. Try again shortly",
  "分享成功": "Shared successfully",
  "工程图片为空，不可分享": "No project image to share",
  "工程画布数据为空": "Canvas data is empty",
  "工程加载失败，请稍后重试": "Failed to load project. Try again",
  "时间不能为空": "Time is required",
  "不能小于当前时间": "Cannot be earlier than now",
  "请填写昵称或手机号再搜索": "Enter nickname or phone to search",
  "删除成功": "Deleted successfully",
  "上一页保存失败，请重试后再切换页面": "Failed to save previous page. Retry before switching",
  "页面加载失败，请重试后再切换页面": "Failed to load page. Retry before switching",
  "AI 功能未开启": "AI is not enabled",
  "页面保存失败，请检查网络后重试": "Failed to save page. Check network and retry",
  "页面加载失败，请检查网络后重试": "Failed to load page. Check network and retry",
  "工程数据加载失败，请稍后重试": "Failed to load project data",
  "生态组件数据不正确，请检查": "Invalid ecosystem component data",
  "按钮个数不得超过最高限制个数": "Button limit reached",
  "不得超过页面最高限制个数": "Page limit reached",
  "未找到当前主页面，请先在左侧树中选中一个主页面": "Select a main page in the left tree",
  "未找到页面，无法复制": "Page not found. Cannot duplicate",
  "父页面不存在，无法复制子页面": "Parent page missing. Cannot duplicate subpage",
  "请至少填写一项再搜索": "Enter at least one field to search",
  "不能将工程交接给自己，请搜索其他接收人": "Cannot hand over to yourself. Search another user",
  "匹配到多人，请用手机号精确搜索": "Multiple matches. Search by exact phone number",
  "请先搜索并选择接收人": "Search and select a recipient first",
  "已下载 license.lic": "license.lic downloaded",
  "生成失败": "Generation failed",
  "请输入驳回原因": "Enter rejection reason",
  "审批成功": "Approved",
  "已重置": "Reset",
  "已更新": "Updated",
  "证书失效时间需要大于证书生效时间": "Expiry must be after effective time",
  "IP、MAC、SN 至少填写一种": "Enter at least one of IP, MAC, or SN",
  "已开始下载": "Download started",
  "下载失败": "Download failed",
  "上传成功": "Uploaded",
  "请先选择要上传的图片": "Select images to upload",
  "请先修改初始密码": "Change your initial password first",
  "发送成功": "Sent",
  "已保存": "Saved",
  "头像处理失败": "Failed to process avatar",
  "密码已修改": "Password updated",
  "手机号已更换": "Phone number updated",
  "已扫码，请输入验证码后确认绑定": "Scanned. Enter SMS code to confirm binding",
  "绑定成功": "Bound successfully",
  "已解绑": "Unbound",
  "调用信息已保存": "API settings saved",
  "用量已更新": "Quota updated",
  "仅超级管理员可新建管理员": "Only super admin can create admins",
  "工程名称不能为空": "Project name is required",
  "页面切换中，请稍后再保存": "Switching pages. Save again shortly",
  "请先点击选择要锁定组件": "Select a component to lock",
  "请先点击选择要解锁的组件": "Select a component to unlock",
  "请先解锁父组件，才能解锁当前组件": "Unlock the parent component first",
  "保存失败，请检查网络": "Save failed. Check network",
  "保存成功": "Saved successfully",
  "校验未通过，已定位到出错组件": "Validation failed. Located the component",
  "有不正确的数据，请检查并修改后再保存": "Invalid data. Fix before saving",
  "请选择协议类型": "Select protocol type",
  "请输入冻结时间": "Enter freeze time",
  "请选择消息进制": "Select message encoding",
  "请选择回车/空格": "Select CR/LF option",
  "请选择回车/换行": "Select CR/LF option",
  "请添加请求体": "Add request body",
  "请添加请求头": "Add request headers",
  "请选择指令类型": "Select command type",
  "请选择请求体类型": "Select body type",
  "请选择白名单状态": "Select whitelist status",
  "请输入白名单设置": "Enter whitelist settings",
  "请选择平台": "Select platform",
  "请输入时间": "Enter time",
  "请输入用途": "Enter purpose",
  "请输入次数": "Enter count",
  "请选择级别": "Select level",
  "生成成功": "Generated",
  "请输入描述": "Enter description",
  "请选择生效时间": "Select effective time",
  "请选择失效时间": "Select expiry time",
  "请选择授权版本": "Select license edition",
  "至少选择一个功能": "Select at least one feature",
  "请输入密钥描述": "Enter key description",
  "请输入密码": "Enter password",
  "请输入确认密码": "Enter password again",
  "请输入正确的手机号": "Enter a valid phone number",
  "请选择上级名称": "Select parent name",
  "请选择型号名称": "Select model name",
  "请选择请求头类型": "Select header type",
  "请选择上级菜单": "Select parent menu",
  "请输入指令类型名称": "Enter command type name",
  "请求头中存在空的值，请检查并补全": "Request headers have empty fields. Complete them",
  "将密码重置为 123456，并强制下次登录改密，同时踢出在线会话？":
    "Reset password to 123456, force change on next login, and sign out all sessions?",
  "重置密码": "Reset password",
  "删除后该模型不再参与自动切换": "This model will no longer be used for failover",
};
